const googleData = {
  googleBtnTxt: 'Google Login',
};

export default googleData;



// WEBPACK FOOTER //
// ./src/components/registration-login/vx-google-login/vx-google-login-i18n.js